import { render, staticRenderFns } from "./FormContainerBlock.vue?vue&type=template&id=84b7c454"
import script from "./FormContainerBlock.vue?vue&type=script&lang=js"
export * from "./FormContainerBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports